import React from 'react';
import styles from '../StoreGuide.module.scss';
import SupportEmailLink from '../../../components/SupportEmailLink/SupportEmailLink';
import DiscordInviteButton from '../../../components/DiscordInviteButton/DiscordInviteButton';

const RockstarSocialClubGuide: React.FC = () => {
  return (
    <div className={styles.guideContent}>
      <div className={styles.guideHeader}>
        <img 
          src={`${process.env.PUBLIC_URL}/images/activation-guides/R_social_club2.png`}
          alt="Rockstar Social Club"
          className={styles.storeLogo}
          onError={(e) => {
            const target = e.currentTarget;
            target.onerror = null;
            target.style.display = 'none';
          }}
        />
        <div className={styles.storeTitle}>
          <h1>Product Key activation on Rockstar Social Club</h1>
          <p>Activate your Rockstar Games keys through the Rockstar Games Launcher</p>
        </div>
      </div>

      <div className={styles.stepsContainer}>
        <div className={styles.steps}>
          
          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>1</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Download Rockstar Games Launcher</h3>
              <div className={styles.stepDescription}>
                In order to redeem games on your Rockstar Social Club account, open your Rockstar Games launcher (you can download Rockstar Games Launcher{' '}
                <a 
                  href="https://socialclub.rockstargames.com/rockstar-games-launcher" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className={styles.inlineLink}
                >
                  here
                </a>
                ).
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>2</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Sign In to Your Account</h3>
              <div className={styles.stepDescription}>
                Sign in with your existing account or create a new one.
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>3</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Access Store and Redeem Code</h3>
              <div className={styles.stepDescription}>
                Go to Store and click the <strong className={styles.boldText}>REDEEM CODE</strong> button which is displayed in the picture below.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/rockstar-step-3.png`}
                  alt="Step 3: Go to Store and click REDEEM CODE"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>4</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>Enter Code and Check</h3>
              <div className={styles.stepDescription}>
                The Rockstar Code activation window will pop up. Simply paste your game code in the designated area and click the <strong className={styles.boldText}>CHECK</strong> button.
              </div>
              <div className={styles.stepImage}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/activation-guides/rockstar-step-4.png`}
                  alt="Step 4: Paste game code and click CHECK"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.onerror = null;
                    target.style.display = 'none';
                  }}
                />
              </div>
            </div>
          </div>

          <div className={styles.step}>
            <div className={styles.stepNumber}>
              <span>5</span>
            </div>
            <div className={styles.stepContent}>
              <h3 className={styles.stepTitle}>OnePlay Support</h3>
              <div className={styles.stepDescription}>
                <div style={{ marginBottom: '12px' }}>
                  For any assistance please contact us via email at <SupportEmailLink /> or join our Discord channel:
                </div>
                <DiscordInviteButton />
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* <div className={styles.additionalNotes}>
        <h3>Important Notes</h3>
        <ul>
          <li>Rockstar Social Club codes are region-specific and must match your account region</li>
          <li>Some games may require additional setup after activation</li>
          <li>Codes can only be used once and cannot be transferred between accounts</li>
          <li>Make sure you have sufficient storage space for the game download</li>
        </ul>
      </div>

      <div className={styles.support}>
        <h3>Need More Help?</h3>
        <p>
          If you encounter any issues during the activation process, visit the official{' '}
          <a 
            href="https://support.rockstargames.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className={styles.supportLink}
          >
            Rockstar Games Support Center
          </a>
          {' '}for additional assistance.
        </p>
      </div> */}
    </div>
  );
};

export default RockstarSocialClubGuide; 